import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import axios from "@/utils/axios";
import * as ICONS from "@/icons";
import { Pagination } from "@/models/pagination.model";

interface Props {
  pagination: Pagination;
  setState: Dispatch<SetStateAction<any>>;
}

const Pagination: React.FC<Props> = ({ pagination, setState }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [firstPage, setFirstPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const isDisabled =
    currentPage === lastPage || lastPage === 0 || lastPage === null;

  useEffect(() => {
    if (pagination?.current === null) return;
    setCurrentPage(pagination?.current);

    if (pagination?.first === null) return;
    setFirstPage(pagination?.first);

    if (pagination?.last === null) return;
    setLastPage(pagination?.last);
  }, [pagination, pagination?.first, pagination?.last]);

  const fetchPage = async (index: number | null) => {
    if (index === null) return;

    const res = await axios.get(`${pagination.baseurl}${index}`);
    setState(res.data);
  };

  return (
    <div className="mt-8 flex items-center justify-center space-x-10 px-4">
      <div className="flex items-center space-x-2">
        <button
          className={`${
            currentPage !== firstPage ? "text-blue-400" : "text-slate-400/30"
          } text-xl`}
          disabled={currentPage === firstPage}
          onClick={() => fetchPage(pagination.first)}
        >
          <ICONS.ChevronDoubleLeftIcon />
        </button>
        <button
          className={`${
            currentPage !== firstPage ? "text-blue-400" : "text-slate-400/30"
          } text-xl`}
          disabled={currentPage === firstPage}
          onClick={() => fetchPage(pagination.previous)}
        >
          <ICONS.ChevronLeftIcon />
        </button>
      </div>
      <div className="text-center">
        <p>
          {currentPage} of {lastPage}
        </p>
      </div>
      <div className="flex items-center space-x-2">
        <button
          className={`${
            !isDisabled ? "text-blue-400" : "text-slate-400/30"
          } text-xl`}
          disabled={isDisabled}
          onClick={() => fetchPage(pagination.next)}
        >
          <ICONS.ChevronRightIcon />
        </button>
        <button
          className={`${
            !isDisabled ? "text-blue-400" : "text-slate-400/30"
          } text-xl`}
          disabled={isDisabled}
          onClick={() => fetchPage(pagination.last)}
        >
          <ICONS.ChevronDoubleRightIcon />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
